import { render, staticRenderFns } from "./rtgs.vue?vue&type=template&id=39710fd9&scoped=true"
import script from "./rtgs.vue?vue&type=script&lang=ts"
export * from "./rtgs.vue?vue&type=script&lang=ts"
import style0 from "./rtgs.vue?vue&type=style&index=0&id=39710fd9&lang=scss"
import style1 from "./rtgs.vue?vue&type=style&index=1&id=39710fd9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39710fd9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39710fd9')) {
      api.createRecord('39710fd9', component.options)
    } else {
      api.reload('39710fd9', component.options)
    }
    module.hot.accept("./rtgs.vue?vue&type=template&id=39710fd9&scoped=true", function () {
      api.rerender('39710fd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transaction/rtgs.vue"
export default component.exports